'use strict';

var moment = require('moment');

var TimeUtils = {

  getMonthFromDateStr: function getMonthFromDateStr(dateStr) {
    // Use strict parsing
    var date = moment(dateStr, 'YYYY-MM-DD', true);
    if (date && date.isValid()) {
      return 'MONTH-' + date.format('YYYY-MM');
    }
    return null;
  },

  getWeekFromDateStr: function getWeekFromDateStr(dateStr) {
    // Use strict parsing
    var date = moment(dateStr, 'YYYY-MM-DD', true);
    if (date && date.isValid()) {
      // Modulo 7 as it starts at 1 for Mondays and 7 for Sundays
      var day = date.isoWeekday() % 7;
      return 'WEEK-' + date.subtract(day, 'days').format('YYYY-MM-DD');
    }
    return null;
  },

  getDifferenceInMinutes: function getDifferenceInMinutes(timeInValue, timeOutValue) {
    // Use strict parsing
    var timeIn = moment(timeInValue, 'h:m a', true);
    if (!timeIn || !timeIn.isValid()) {
      return 0;
    }
    // Use strict parsing
    var timeOut = moment(timeOutValue, 'h:m a', true);
    if (!timeOut || !timeOut.isValid()) {
      return 0;
    }
    var timespan = moment.duration(timeOut.diff(timeIn));
    var result = timespan.asMinutes();
    // Handle day to day values 
    if (result < 0) {
      result += 60 * 24;
    }
    return result;
  },

  /**
   * Gets the time interval in minutes in a clocking day object.
   * That is, clockout/clockin - lunch
   */
  getIntervalTimeFromClocking: function getIntervalTimeFromClocking(value) {
    var day = 0,
        lunch = 0;
    if (value && value.timeIn && value.timeOut) {
      day = TimeUtils.getDifferenceInMinutes(value.timeIn, value.timeOut);
    }
    if (value && value.timeLunchIn && value.timeLunchOut) {
      lunch = TimeUtils.getDifferenceInMinutes(value.timeLunchIn, value.timeLunchOut);
    }
    return day - lunch;
  },

  /**
   * Aggregates the event times, including shifts.
   */
  getIntervalTimeFromEvent: function getIntervalTimeFromEvent(value) {
    var result = 0;
    if (value && value.timeIn && value.timeOut) {
      result = TimeUtils.getDifferenceInMinutes(value.timeIn, value.timeOut);
    }
    if (value && value.shifts) {
      for (var shiftId in value.shifts) {
        var shift = value.shifts[shiftId];
        if (shift && shift._type !== 'deleted' && shift.timeIn && shift.timeOut) {
          result += TimeUtils.getDifferenceInMinutes(shift.timeIn, shift.timeOut);
        }
      }
    }
    return result;
  }

};

module.exports = TimeUtils;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/TimeUtils.js
// module id = 1038
// module chunks = 0